import {
  REQUEST_COMPANIES,
  RESPONSE_COMPANIES,
  REQUEST_COMPANIES_FAILURE,
  REQUEST_COMPANIES_TO_OWNERSHIP,
  RESPONSE_COMPANIES_TO_OWNERSHIP,
  REQUEST_COMPANIES_TO_OWNERSHIP_FAILURE,
  REQUEST_UPDATE_COMPANY,
  RESPONSE_UPDATE_COMPANY,
  REQUEST_UPDATE_COMPANY_FAILURE,
  REQUEST_CREATE_OWNERSHIPAREA,
  RESPONSE_CREATE_OWNERSHIPAREA,
  REQUEST_CREATE_OWNERSHIPAREA_FAILURE,
  REQUEST_CREATE_COMPANY,
  RESPONSE_CREATE_COMPANY,
  REQUEST_CREATE_COMPANY_FAILURE,
  REQUEST_COMPANY,
  RESPONSE_COMPANY,
  REQUEST_COMPANY_FAILURE,
  REQUEST_TRANSFER_UNITS_TO_COMPANY,
  RESPONSE_TRANSFER_UNITS_TO_COMPANY,
  REQUEST_TRANSFER_UNITS_TO_COMPANY_FAILURE,
  REQUEST_ENTERING_COMPANY,
  RESPONSE_ENTERING_COMPANY,
  REQUEST_ENTERING_COMPANY_FAILURE,
  REQUEST_DOWNLOAL_COMPANY_INFO,
  RESPONSE_DOWNLOAL_COMPANY_INFO,
  REQUEST_DOWNLOAL_COMPANY_INFO_FAILURE,
  downloadCompanyInfo,
} from "../actions/companiesActions";

import { RESPONSE_CREATE_DEVICE_COMMAND, RESPONSE_DELETE_DEVICE_COMMAND } from "../actions/devicesAction";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  createOwnershipAreaDataState: states.NOT_REQUESTED,
  updateCompanyDataState: states.NOT_REQUESTED,
  setToOwnershitDataState: states.NOT_REQUESTED,
  companyDataState: states.NOT_REQUESTED,
  transferUnitToCompanyDataState: states.NOT_REQUESTED,
  enteringCompanyDataState: states.NOT_REQUESTED,
  downloadCompanyInfoDataState: states.NOT_REQUESTED,
  company: null,
  ownershipAreas: {},
  errors: [],
};

const companiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_COMPANIES:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
        ownershipAreas: {},
      });
    case RESPONSE_COMPANIES:
      return Object.assign({}, state, {
        dataState: states.READY,
        ownershipAreas: action.data,
      });
    case REQUEST_COMPANIES_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_COMPANIES_TO_OWNERSHIP:
      return Object.assign({}, state, {
        setToOwnershitDataState: states.REQUEST,
      });
    case RESPONSE_COMPANIES_TO_OWNERSHIP:
      let transferCompanies = [];

      const ownershipAreas = {
        ownershipAreas: state.ownershipAreas.ownershipAreas.map((area) => {
          if (area.id === action.id) {
            transferCompanies = area.companies.filter((company) => {
              return action.data.includes(company.id);
            });

            area.companies = area.companies.filter((company) => {
              return !action.data.includes(company.id);
            });

            area.companyCount -= transferCompanies.length;
            area.count -= transferCompanies.length;
            area.deviceCount -= transferCompanies.reduce((a, b) => a + (b.deviceCount || 0), 0);
            area.deviceInActiveCount -= transferCompanies.reduce((a, b) => a + (b.deviceInActiveCount || 0), 0);
          }

          return area;
        }),
      };

      ownershipAreas.ownershipAreas = state.ownershipAreas.ownershipAreas.map((area) => {
        if (area.id === action.toId) {
          area.companies = area.companies.concat(transferCompanies);

          area.companyCount += transferCompanies.length;
          area.count += transferCompanies.length;
          area.deviceCount += transferCompanies.reduce((a, b) => a + (b.deviceCount || 0), 0);
          area.deviceInActiveCount += transferCompanies.reduce((a, b) => a + (b.deviceInActiveCount || 0), 0);
        }

        return area;
      });

      return Object.assign({}, state, {
        setToOwnershitDataState: states.READY,
        ownershipAreas: ownershipAreas,
      });
    case REQUEST_COMPANIES_TO_OWNERSHIP_FAILURE:
      return Object.assign({}, state, {
        setToOwnershitDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UPDATE_COMPANY:
      return Object.assign({}, state, {
        updateCompanyDataState: states.REQUEST,
      });
    case RESPONSE_UPDATE_COMPANY:
      const data = {
        ownershipAreas: state.ownershipAreas.ownershipAreas.map((area) => {
          area.companies = area.companies.map((company) => {
            if (action.data.id === company.id) {
              return action.data;
            }

            return company;
          });

          return area;
        }),
      };

      return Object.assign({}, state, {
        updateCompanyDataState: states.READY,
        ownershipAreas: data,
      });
    case REQUEST_UPDATE_COMPANY_FAILURE:
      return Object.assign({}, state, {
        updateCompanyDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_OWNERSHIPAREA:
      return Object.assign({}, state, {
        createOwnershipAreaDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_OWNERSHIPAREA:
      const addOwnershipAreas = {
        ownershipAreas: state.ownershipAreas.ownershipAreas.concat(action.data),
      };

      return Object.assign({}, state, {
        createOwnershipAreaDataState: states.READY,
        ownershipAreas: addOwnershipAreas,
      });
    case REQUEST_CREATE_OWNERSHIPAREA_FAILURE:
      return Object.assign({}, state, {
        createOwnershipAreaDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_COMPANY:
      return Object.assign({}, state, {
        createCompanyDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_COMPANY:
      const createCompanyOwnershipAreas = {
        ownershipAreas: state.ownershipAreas.ownershipAreas.map((area) => {
          if (area.id === action.ownershipAreaId) {
            const company = action.data;
            company.dateCreation = new Date(Date.parse(company.dateCreation));
            company.datePayment = new Date(Date.parse(company.datePayment));

            area.companies = [company].concat(area.companies);
          }

          return area;
        }),
      };

      return Object.assign({}, state, {
        createCompanyDataState: states.READY,
        ownershipAreas: createCompanyOwnershipAreas,
      });
    case REQUEST_CREATE_COMPANY_FAILURE:
      return Object.assign({}, state, {
        createCompanyDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_COMPANY:
      return Object.assign({}, state, {
        companyDataState: states.REQUEST,
      });
    case RESPONSE_COMPANY:
      return Object.assign({}, state, {
        companyDataState: states.READY,
        company: action.data,
      });
    case REQUEST_COMPANY_FAILURE:
      return Object.assign({}, state, {
        companyDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_TRANSFER_UNITS_TO_COMPANY:
      return Object.assign({}, state, {
        transferUnitToCompanyDataState: states.REQUEST,
      });
    case RESPONSE_TRANSFER_UNITS_TO_COMPANY:
      const { company } = state;

      if (company === null) {
        return state;
      }

      company.units = company.units.filter((x) => {
        return !action.data.includes(x.id);
      });

      return Object.assign({}, state, {
        transferUnitToCompanyDataState: states.READY,
        company: company,
      });
    case REQUEST_TRANSFER_UNITS_TO_COMPANY_FAILURE:
      return Object.assign({}, state, {
        transferUnitToCompanyDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_ENTERING_COMPANY:
      return Object.assign({}, state, {
        enteringCompanyDataState: states.REQUEST,
      });
    case RESPONSE_ENTERING_COMPANY:
      return Object.assign({}, state, {
        enteringCompanyDataState: states.READY,
      });
    case REQUEST_ENTERING_COMPANY_FAILURE:
      return Object.assign({}, state, {
        enteringCompanyDataState: states.FAILURE,
        errors: action.errors,
      });

    case RESPONSE_CREATE_DEVICE_COMMAND:
      const __company = state.company;

      __company.units.forEach((unit) => {
        unit.devices.forEach((device) => {
          if (device.id === action.data.id) {
            device.command = action.data.command;
          }
        });
      });

      return Object.assign({}, state, {
        company: __company,
      });

    case RESPONSE_DELETE_DEVICE_COMMAND:
      const ___company = state.company;

      ___company.units.forEach((unit) => {
        unit.devices.forEach((device) => {
          if (device.id === action.data.id) {
            device.command = null;
          }
        });
      });

      return Object.assign({}, state, {
        company: ___company,
      });

    case RESPONSE_DOWNLOAL_COMPANY_INFO:
      return Object.assign({}, state, {
        downloadCompanyInfo: states.REQUEST,
      });

    case REQUEST_DOWNLOAL_COMPANY_INFO:
      return Object.assign({}, state, {
        downloadCompanyInfo: states.READY,
      });

    case REQUEST_DOWNLOAL_COMPANY_INFO_FAILURE:
      return Object.assign({}, state, {
        downloadCompanyInfo: states.FAILURE,
      });

    default:
      return state;
  }
};

export default companiesReducer;
